<template>
  <div class="recharge-order-list">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
        <!-- <van-list v-model="loading" :finished="finished" @load="onLoad"> -->
        <div class="order-item" v-for="(item, i) in list" :key="i">
          <div class="fake-button" @click="toOrderDetail(item)">
            <div class="title">
              <div class>
                <span class="icon">充</span>
                <span class="recharge-center">充值中心</span>
              </div>
              <span class="order-status" v-if="item.status == 1">待付款</span>
              <span class="order-status" v-if="item.status == 2">正充值</span>
              <span class="order-status" v-if="item.status == 3">正充值</span>
              <span class="order-status" v-if="item.status == 4">已完成</span>
              <span class="order-status" v-if="item.status == 5">已关闭</span>
              <div class="recharge-failed" v-if="item.status == 3">充值失败，请联系客服</div>
            </div>
            <div class="platform">{{item.title}}</div>
            <!-- TODO 这里要求后端返回charge_id字段，现在还没有 -->
            <div class="light-font" v-if="platformWithCard.includes(item.charge_id) && item.status == 4">兑换码：{{item.card_password}}</div>
            <div class="light-font" v-if="!platformWithCard.includes(item.charge_id) && item.charge_id != 14 && item.charge_id != 15">充值账号：{{item.charge_account}}</div>
            <div class="light-font" v-if="! platformWithCard.includes(item.charge_id) && (item.charge_id == 14 || item.charge_id == 15)">充值账号：{{HandlecardNumber(item.charge_account)}}</div>

            <div class="light-font">产品名称：{{item.product_name}}</div>
            <div class="light-font" v-if="(item.charge_id == 14 || item.charge_id == 15) && item.status == 4">充值时间：{{item.recharge_time}}</div>
            <div class="light-font" v-if="(item.charge_id == 14 || item.charge_id == 15) && item.status == 4">{{item.giving_credits_status == 1 ? '待领取积分':'已领取积分'}}：{{item.giving_credits}}</div>
            <div class="price">
              <span>实付款：¥</span>
              <!-- <span v-if="item.actual_amount">{{parseFloat(item.actual_amount).toFixed(2)}}</span> -->
              <span>{{parseFloat(item.actual_amount).toFixed(2)}}</span>

            </div>
          </div>

          <div class="btn">
            <div v-if="item.status == 1">
              <button class="btn-default" @click="cancelOrder(item)">取消订单</button>
              <button class="btn-default" @click="chat">联系客服</button>
              <button class="btn-primary" @click="rechargePay(item)">立即付款</button>
            </div>
            <!-- <div v-if="item.status == 2"> -->
            <div v-if="[2, 3].includes(item.status)">
              <button class="btn-default" @click="chat">联系客服</button>
            </div>
            <!-- <div v-if="[3, 4, 5].includes(item.status)"> -->
            <div v-if="[4, 5].includes(item.status)">
              <button class="btn-default" @click="delOrder(item)" v-if="((item.charge_id == 14 || item.charge_id == 15) && (item.giving_credits_status != 1 || item.status==5)) || (item.charge_id !== 14 && item.charge_id !== 15)">删除订单</button>
              <button class="btn-primary" v-if="item.giving_credits_status == 1 && (item.charge_id == 14 || item.charge_id == 15) && item.status == 4" @click="getCredits(item)">领取积分</button>
              <button class="btn-default" v-if="item.giving_credits_status == 2 && (item.charge_id == 14 || item.charge_id == 15) && item.status == 4">积分已结算</button>
              <button class="btn-default" @click="chat">联系客服</button>
            </div>
          </div>
        </div>
      </van-list>
      <div class="empty-list" :style="emptyList" v-if="! loading && ! refreshing && ! list.length">暂无订单</div>
    </van-pull-refresh>
    <van-dialog v-model="showDialog" :message="dialogMessage" :confirm-button-text="confirmText" confirm-button-color="#F9591B" :cancel-button-text="cancelText" cancel-button-color="#999999" @confirm="confirmEvent" show-cancel-button>
    </van-dialog>

    <div class="order-list-loading" v-if="loading1">
      <img src="../../../assets/common/loading.gif" />
    </div>

  </div>
</template>

<script>
  import { Toast } from 'vant';
  // import { tr } from 'date-fns/locale';
  import { getThirdrechargeOilCredits } from '../api/index'
  export default {
    name: "rechargeOrderList",
    props: {
      orderStatus: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        page: 0,
        status: 0,
        statusText: '',
        dialogMessage: '',
        confirmText: '',
        cancelText: '',
        showDialog: false,
        // 9->网易云音乐  11->百度网盘
        platformWithCard: [9, 11],
        refreshing1: false,
        emptyList: {
          // width: document.body.clientWidth + 'px',
          // height: document.body.clientHeight + 'px',
          'padding-top': (document.body.clientHeight / 2 - 132 - 24 / 2) + 'px',
        },
        loading1: false,
      };
    },
    created() {},
    mounted() {
      document.querySelectorAll('.van-pull-refresh__track').forEach(item => {
        item.style['min-height'] = (document.body.clientHeight - 132) + 'px'
      })
    },
    computed: {
      finishedText() {
        return this.list.length ? '没有更多了' : ''
      },
    },
    methods: {
      onLoad() {
        this.getOrderList();
      },
      onRefresh() {
        // this.finished = false;
        this.page = 0;
        this.onLoad();
      },
      doOnRefresh1() {
        this.refreshing1 = true
        // this.finished = false;
        this.page = 0;
        this.onLoad();
      },
      getOrderList() {
        this.page++
        let params = {};
        if ([0, 2].includes(this.orderStatus)) {
          params = {
            page: this.page,
          };
        }
        if ([1, 4, 5].includes(this.orderStatus)) {
          params = {
            page: this.page,
            status: this.orderStatus,
          };
        }
        this.$api.post("/thirdrecharge/member/order/list", params).then((res) => {

            let _list = res.data
            if (this.orderStatus === 2) {
              _list = _list.filter((item) => [2, 3].includes(item.status))
            }
            if (this.refreshing || this.refreshing1) {
              this.list = [];
              this.finished = false;
              this.refreshing1 = false
            }

            this.list.push(..._list)

            if (this.list.length === 0 || _list.length === 0) {
              this.finished = true;
              this.loading = false;
              this.refreshing = false;
              return;
            }

            this.loading = false;

            if (res.current_page == res.last_page) { // 数据全部加载完成
              this.finished = true;
            }

            if (this.refreshing) {
              this.$toast("刷新成功");
              this.refreshing = false;
            }

            if (!this.finished && !this.loading && this.list.length <= 2) {
              this.onLoad()
            }

          })
          .catch(() => {
            this.finished = true
          })
      },
      toOrderDetail(item) {
        if (item.charge_id == 14 || item.charge_id == 15) {
          this.$router.push({
            path: '/new-oli/orderdetail',
            query: {
              order_sn: item.ordersn,
              order_id: item.order_id,
              charge_type: item.charge_type,
              token: localStorage.getItem('_token'),
              orderStatus: this.orderStatus,
            }
          })
        } else {
          this.$router.push({
            path: '/recharge/orderDetail',
            query: {
              order_id: item.order_id,
              charge_type: item.charge_type,
              token: localStorage.getItem('_token'),
              orderStatus: this.orderStatus,
            }
          })
        }
      },
      floatNumPoint(num, point_num = 2) {
        const num_list = String(num).split('.')
        let new_num = ''
        if (num_list.length == 2) {
          new_num = num_list[0] + '.' + (num_list[1].slice(0, point_num).length == point_num ? num_list[1].slice(0, point_num) : num_list[1].slice(0, point_num) + '0') // 通用方法，这里有点问题
        } else {
          new_num = num_list[0] + '.00'
        }
        return new_num
      },
      HandlecardNumber(number) {
        let new_number = ''
        for (let index in number) {
          new_number += number[index]
          if (index % 4 == 3) {
            new_number += ' '
          }
        }
        return new_number
      },
      confirmEvent() {},
      cancelOrder(item) {
        this.dialogMessage = '您是否要取消该订单？'
        this.confirmText = '确认取消'
        this.cancelText = '返回'
        this.confirmEvent = () => {
          this.loading1 = true
          this.$api.post('/order/member/order/cancel', {
              ordersn: item.ordersn
            })
            .then(res => {
              // item.status = 4
              this.showDialog = false
              // 取消成功后手动刷新10次，每次间隔1s，直到状态正确
              let countLimit1 = 0
              const intervalId1 = setInterval(() => {
                countLimit1++
                for (let i = 0; i < this.list.length; i++) {
                  if (this.list[i].ordersn === item.ordersn && this.list[i].status == 5) {
                    clearInterval(intervalId1)
                    this.loading1 = false
                    return
                  }
                }
                this.doOnRefresh1()
                if (countLimit1 >= 10) {
                  clearInterval(intervalId1)
                  this.loading1 = false
                }
              }, 1000)
            })

            .catch(err => {
              this.showDialog = false
              this.loading1 = false
            })
        }
        this.showDialog = true
      },
      chat() {
        this.params("", "", "chat");
      },
      rechargePay(item) {
        let param = {
          actual_amount: parseFloat(item.actual_amount).toFixed(2),
          deduct_coin: item.deduct_coin,
          deduct_credits: item.deduct_credits,
          order_amount: parseFloat(item.order_amount).toFixed(2),
          ordersn: item.ordersn,
        };
        this.params(JSON.stringify(param), JSON.stringify(param), "rechargePay");
      },
      delOrder(item) {
        this.dialogMessage = '您是否要删除该订单？'
        this.confirmText = '确认删除'
        this.cancelText = '取消'
        this.confirmEvent = () => {
          this.loading1 = true
          this.$api.post('/order/member/order/delete', {
              ordersn: item.ordersn
            })
            .then(res => {
              if (item.charge_id != 14 && item.charge_id != 15) {
                item.status = 4
              }
              this.showDialog = false
              // 删成功后手动刷新10次，每次间隔1s，直到状态正确
              let countLimit2 = 0
              const intervalId2 = setInterval(() => {
                countLimit2++
                let flag = 0
                for (let i = 0; i < this.list.length; i++) {
                  if (this.list[i].ordersn === item.ordersn) {
                    flag = 1
                    break
                  }
                }
                if (flag == 1) {
                  this.doOnRefresh1()
                } else {
                  clearInterval(intervalId2)
                  this.loading1 = false
                }


                if (countLimit2 >= 10) {
                  clearInterval(intervalId2)
                  this.loading1 = false
                }
              }, 1000)

            })
            .catch(err => {
              this.showDialog = false
              this.loading1 = false
            })
        }
        this.showDialog = true
      },
      getCredits(item) {
        getThirdrechargeOilCredits({ order_sn: item.ordersn }).then((res) => {
          Toast('领取成功')
          this.doOnRefresh1()
        })
      }
    },
  };
</script>

<style lang="less" scoped>
  .recharge-order-list {
    .van-list {
      // min-height: 580px;
    }

    background-color: #f5f6f7;

    .order-item {
      background-color: #ffffff;
      box-sizing: border-box;
      margin: 12px;
      padding: 12px;
      border-radius: 10px;

      .title {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .icon {
          display: inline-block;
          border-radius: 50%;
          height: 20px;
          width: 20px;
          text-align: center;
          background: linear-gradient(270deg,
              rgba(244, 26, 60, 1) 0%,
              rgba(252, 116, 12, 1) 100%);
          font-size: 13px;
          color: #ffffff;
          line-height: 21px;
        }

        .recharge-center {
          height: 12px;
          line-height: 24px;
          margin-left: 8px;
          font-size: 15px;
          color: #333333;
        }

        .order-status {
          color: #f9591b;
          font-size: 14px;
        }

        .recharge-failed {
          position: absolute;
          right: 0;
          bottom: -17px;
          color: #f41a3c;
          font-size: 12px;
          height: 19px;
          line-height: 19px;
        }
      }

      .platform {
        height: 26px;
        line-height: 26px;
        color: #333333;
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: 500;
      }

      .light-font {
        height: 21px;
        line-height: 21px;
        color: #999999;
        margin-bottom: 1px;
        font-size: 13px;
      }

      .price {
        color: #333333;
        font-size: 13px;
        text-align: right;
        margin: 11px 0 12px;

        span:nth-of-type(2) {
          font-size: 16px;
          font-weight: 600;
        }

        // span:nth-of-type(3) {
        //   font-size: 12px;
        // }
      }

      .btn {
        height: 30px;
        line-height: 30px;
        padding: 3px 0 4px 0;
        text-align: right;

        button {
          // 去除button默认样式
          border: none;
          outline: none;
          -webkit-appearance: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }

        .btn-primary {
          position: relative;
          margin-left: 12px;
          padding: 0 12px;
          font-size: 14px;
          color: #f9591b;
          background-color: #ffffff;
          box-sizing: border-box;

          // border-radius:15px;
          // border: 1px solid #ffffff;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            width: 200%;
            height: 200%;
            border: 1px solid #f9591b;
            border-radius: 30px;
            /* 也可以设置圆角 */
            -webkit-transform-origin: 0 0;
            -moz-transform-origin: 0 0;
            -ms-transform-origin: 0 0;
            -o-transform-origin: 0 0;
            transform-origin: 0 0;
            -webkit-transform: scale(0.5, 0.5);
            -ms-transform: scale(0.5, 0.5);
            -o-transform: scale(0.5, 0.5);
            transform: scale(0.5, 0.5);
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
          }
        }

        .btn-default {
          position: relative;
          margin-left: 12px;
          padding: 0 12px;
          font-size: 14px;
          color: #999999;
          background-color: #ffffff;
          box-sizing: border-box;

          // border-radius:15px;
          // border: 1px solid #ffffff;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            width: 200%;
            height: 200%;
            border: 1px solid #999999;
            border-radius: 30px;
            /* 也可以设置圆角 */
            -webkit-transform-origin: 0 0;
            -moz-transform-origin: 0 0;
            -ms-transform-origin: 0 0;
            -o-transform-origin: 0 0;
            transform-origin: 0 0;
            -webkit-transform: scale(0.5, 0.5);
            -ms-transform: scale(0.5, 0.5);
            -o-transform: scale(0.5, 0.5);
            transform: scale(0.5, 0.5);
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
          }
        }
      }
    }

    .empty-list {
      text-align: center;
      background-color: #f5f6f7;
      height: 24px;
      line-height: 24px;
      font-size: 18px;
      color: #999999;
    }

    .van-dialog {
      width: 274px;
      border-radius: 3px;

      .van-dialog__content {
        .van-dialog__message {
          font-size: 16px;
          padding: 30px 57px;
        }
      }
    }

    .order-list-loading {
      text-align: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);

      img {
        width: 35%;
        margin-top: 65%;
      }
    }

  }
</style>